import React, { useEffect, useRef } from "react";

// Example partner data (replace with real logos/links as needed)
const partners = [
    { name: "Microsoft", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/microsoft/microsoft-original.svg" },
    { name: "Windows", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/windows8/windows8-original.svg" },
    { name: "Dell", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dell/dell-original.svg" },
    { name: "HP", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/hp/hp-original.svg" },
    { name: "Samsung", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/samsung/samsung-original.svg" },
    { name: "Amazon", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original.svg" },
    { name: "AWS", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original.svg" },
    { name: "MongoDB", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" },
    { name: "SQL Server", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/microsoftsqlserver/microsoftsqlserver-plain.svg" },
    { name: "Linux", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg" },
    { name: "IBM", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/ibm/ibm-original.svg" },
    { name: "Oracle", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/oracle/oracle-original.svg" },
    { name: "Apple", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apple/apple-original.svg" },
    { name: "Google", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg" },
    { name: "Facebook", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/facebook/facebook-original.svg" },
];

const scrollAmount = 200; // px
const scrollInterval = 2500; // ms

const Partners = () => {
    const scrollRef = useRef(null);

    useEffect(() => {
        const interval = setInterval(() => {
            if (scrollRef.current) {
                const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
                if (scrollLeft + clientWidth >= scrollWidth) {
                    scrollRef.current.scrollTo({ left: 0, behavior: "smooth" });
                } else {
                    scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
                }
            }
        }, scrollInterval);
        return () => clearInterval(interval);
    }, []);

    return (
        <section style={{ padding: "2rem 0", background: "#f9f9f9" }}>
            <h2 style={{ textAlign: "center", marginBottom: "1.5rem" }}>Our IT Partners</h2>
            <div
                ref={scrollRef}
                style={{
                    display: "flex",
                    overflowX: "auto",
                    scrollBehavior: "smooth",
                    gap: "2rem",
                    padding: "1rem",
                    scrollbarWidth: "none",
                }}
            >
                {partners.map((partner) => (
                    <div
                        key={partner.name}
                        style={{
                            minWidth: 120,
                            minHeight: 80,
                            background: "#fff",
                            borderRadius: 12,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "1rem",
                        }}
                    >
                        <img
                            src={partner.icon}
                            alt={partner.name}
                            style={{ width: 48, height: 48, marginBottom: 8 }}
                            onError={e => {
                                e.target.onerror = null;
                                e.target.src = "https://via.placeholder.com/48?text=Logo";
                            }}
                        />
                        <span style={{ fontSize: 14, color: "#333" }}>{partner.name}</span>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Partners;